// English translations for mobile app
export const en = {
  // Common
  welcome: "Welcome",
  next: "Next",
  back: "Back",
  submit: "Submit",
  cancel: "Cancel",
  loading: "Loading...",
  error: "Error",
  success: "Success",
  and: "and",

  // Auth
  login: "Login",
  register: "Register",
  email: "Email",
  password: "Password",
  firstName: "First Name",
  lastName: "Last Name",
  forgotPassword: "Forgot Password?",

  // Validation Messages
  fieldRequired: "This field is required",
  emailRequired: "Email is required",
  passwordRequired: "Password is required",
  invalidEmail: "Please enter a valid email address",
  passwordTooShort: "Password must be at least 6 characters",

  // Login & Auth UI
  welcomeBack: "Welcome Back",
  signInToContinue: "Sign in to continue",
  rememberMe: "Remember me",
  loginWith: "Login with",
  dontHaveAccount: "Don't have an account?",
  orContinueWith: "or continue with",
  enterEmail: "Enter your email",
  enterPassword: "Enter your password",

  // Register UI
  createAccount: "Create Account",
  signUpToGetStarted: "Sign up to get started",
  joiningCompany: "Joining company",
  fullName: "Full Name",
  enterName: "Enter your full name",
  confirmPassword: "Confirm Password",
  reEnterPassword: "Re-enter your password",
  iAgreeToThe: "I agree to the",
  termsOfService: "Terms of Service",
  privacyPolicy: "Privacy Policy",
  alreadyHaveAccount: "Already have an account?",
  nameMinLength: "Name must be at least 2 characters",
  passwordsDoNotMatch: "Passwords do not match",
  mustAgreeToTerms: "You must agree to Terms of Service and Privacy Policy",
  signIn: "Sign In",

  // Liveness Check
  moveFaceIntoFrame: "Move your face into the frame",
  livenessSmile: "Please smile broadly",
  livenessBlink: "Please blink your eyes",
  livenessTurnLeft: "Turn your head to the left",
  livenessTurnRight: "Turn your head to the right",
  multipleFacesDetected: "Only one person allowed",
  captureError: "Failed to capture image",
  verifying: "Verifying...",
  smile: "Smile",
  turnLeft: "Turn Left",
  turnRight: "Turn Right",
  blink: "Blink",

  // API & Errors
  unknownError: "An unknown error occurred.",
  apiConnectionError: "API connection error",
  unknown3DLivenessError: "Unknown 3D liveness error",
  livenessVerificationFailed: "Liveness verification failed. Please try again.",
  networkError: "Network error. Please check your connection.",
  nA: "N/A",
  unknown: "Unknown",

  // Super Admin Panel
  totalUsers: "Total Users",
  companies: "Companies",
  submissions: "Submissions",
  pendingReview: "Pending Review",
  userManagement: "User Management",
  allSubmissions: "All Submissions",
  systemHealth: "System Health",
  alerts: "Alerts",
  systemSettings: "System Settings",
  languageSettings: "Language Settings",
  analytics: "Analytics",
  securityLogs: "Security & Logs",
  superAdminPanel: "Super Admin Panel",
  manageYourPlatform: "Manage your entire platform",
  loadingDashboard: "Loading dashboard...",
  navigationError: "Unable to navigate to this screen.",
  retry: "Retry",
};
